import { useMsal } from "@azure/msal-react";
import useAccessToken from "../../../../../hooks/useAccessToken";
import { marked } from "marked";
import { Thread, Message } from "../../../../../types/types";
import styles from "./Feedback.module.scss";
import { useState } from "react";

interface SendEmailProps {
  selectedThread: Thread;
  message: Message;
}

const SendEmail = ({ selectedThread, message }: SendEmailProps) => {

    const { accounts } = useMsal();
    const accessToken = useAccessToken();
    
    const email = accounts[0]?.username;
    const threadName = selectedThread?.title;

    const subject = "Note from Georges: " + threadName;

    const introductiveText = "<p><h3>This is a note from Georges about: " + threadName + ".</h3></p>"

    var cleanedContent = message.content.replace(/<span[^>]*>/g, '<i>[Source: ').replace(/<\/span>/g, ']</i>');
    //.replace(/<[^>]*>?/g, '');
    //cleanedContent = cleanedContent.replace(/[*_~#`]/g, '');
    const body = introductiveText + marked(cleanedContent as string);
    const [isSent, setIsSent] = useState(false);

    const sendEmail = async (accessToken) => {
      const emailData = {
          message: {
              subject: subject,
              body: {
                  contentType: "HTML",
                  content: body,
              },
              toRecipients: [
                  {
                      emailAddress: {
                          address: email,
                      },
                  },
              ],
          },
      };
  
      const response = await fetch("https://graph.microsoft.com/v1.0/me/sendMail", {
          method: "POST",
          headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
          },
          body: JSON.stringify(emailData),
      });
  
      if (response.ok) {
          console.log("Email sent successfully!");
          setIsSent(true);
      } else {
          console.error("Failed to send email", await response.text());
      }
  };

      return(
        <>
        <button  
          onClick={() => sendEmail(accessToken)} 
          className={isSent ? styles.sendEmailClicked : styles.sendEmail}
          disabled={isSent}>
          {isSent ? <i className={`bi bi-envelope-fill`}></i> : <i className={`bi bi-envelope`}></i>}
          {isSent && <span className={styles.sentText}>Mail Sent</span>}
        </button>
      </>)
  }

export default SendEmail;